import styled from 'styled-components';

export const Container = styled.span`
  font-family: 'Aller-Light' !important;
  font-size: 1rem !important;
  color: #949494 !important;
  cursor: auto !important;
`;
